import {createFileRoute, redirect} from '@tanstack/react-router'

/** Redirect legacy wizard step URLs to /jobs/create. */
export const Route = createFileRoute('/_app/jobs/create/$step')({
    beforeLoad: () => {
        throw redirect({to: '/jobs/create', replace: true})
    },
})
